//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Bristol',
  data() {
    return {
      icons: [
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_1%402x.png',
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_2%402x.png',
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_3%402x.png',
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_4%402x.png',
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_5%402x.png',
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_6%402x.png',
        'https://studioyszimg.yxj.org.cn/yszFormulas/imgs/Chart_Bristol_icon_7%402x.png',
      ],
      descList: [
        '一颗颗硬球（很难通过）。',
        '香肠状，但表面凹凸。',
        '香肠状，但表面有裂痕。',
        '像香肠或蛇一样，且表面很光滑。',
        '断边光滑的柔软块状。',
        '粗边蓬松块，糊状大便。',
        '水样，不成形。完全液体。',
      ],
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Nurse/Chart_Bristol.vue